import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  CircularProgress,
  MenuItem,
  Select,
  Typography,
  Chip,
  Box,
  InputLabel,
  FormControl,
} from "@material-ui/core";

import jwt from "jsonwebtoken";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
function UsersByRoleMulti({
  label,
  placehold,
  apiString,
  nameInstate,
  refId,
  formState,
  changeHandler,
  required,
  disabled,
  classes,
  loginid,
}) {
  const [userData, setUserData] = useState([]);
  const [filterloginUser, setFilterLoginUser] = useState([]);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("user_token");
  const user = jwt.decode(token);
  const getUsers = async () => {
    setLoading(true);
    getUsersByRole(apiString, setUserData, setLoading);

  };
  useEffect(() => {
    getUsers();
  }, []);
  const getUsersByRole = async (
    user,
    setUserData,
    setLoading,

  ) => {
    await axios({
      method: "post", //you can set what request you want to be
      url: `${process.env.REACT_APP_API_URL}/api/Role/GetUserList_v2/${user}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
        "Content-Type": "application/json",
      },
      // data: formState,
    })
      .then(async (res) => {

        const transformedArray = res.data.map((obj) => {
          const {
            userId,
            userName
          } = obj;

          return {
            referenceId: refId?.referenceId,
            referenceKey: '',
            referenceCode: userId,
            referenceText: userName,
            referenceProp1: 'email',
            referenceProp2: '',
            referenceProp3: '',
            referenceProp4: '',
            isActive: true,
          };
        });
        setUserData(transformedArray);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);

        // setErrorMessage("Invalid username or password");
      });
  };
  return (
    <div>
      <Typography>{label}</Typography>

      <FormControl fullWidth size="small">
        <Select
          displayEmpty
          multiple
          name={nameInstate}
          value={formState[nameInstate]}
          onChange={(event) => {
            // setuserRole(event.target.value);
            const {
              target: { value, name },
            } = event;

            changeHandler(name, value);
          }}
          style={{ height: 30 }}
          MenuProps={MenuProps}
        >
          <MenuItem value={[]} disabled>
            Select a Value
          </MenuItem>
          {!loading ? (
            userData.length > 0 ? (
              userData.map((item, index) => (
                <MenuItem
                  key={index}
                  value={item}
                  sx={{ color: "black !important" }}
                >
                  {item.referenceText}
                </MenuItem>
              ))
            ) : (
              <MenuItem disabled>Not Found</MenuItem>
            )
          ) : (
            <MenuItem>
              <CircularProgress size={24} />
            </MenuItem>
          )}
        </Select>
      </FormControl>
    </div>
  );
}

export default UsersByRoleMulti;
